/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState } from 'react';
import { sections } from '../../pages/SavedListingsPage/SavedListingsPage.types';
import { useRouter } from 'next/router';
import { SavedListingSection } from 'listing-details/types';
import { trackSectionChange } from '../../pages/SavedListingsPage/SavedListingsPage.tracking';
import {
    SavedListingsBySection,
    OrderedFilteredSavedListingsBySection
} from '../../hooks/useSavedListings/useSavedListings';
import { Saved_ListingFragment } from 'listing-details/queries/SavedListing.fragment.generated';

export const useSelectedSection = (
    savedListings?: Array<Saved_ListingFragment>,
    savedListingsBySection?: SavedListingsBySection,
    orderedFilteredSavedListingsBySection?: OrderedFilteredSavedListingsBySection
): {
    selectedSection: SavedListingSection;
    onSectionChange: (section: SavedListingSection) => void;
} => {
    const router = useRouter();

    const getSelectedSection = (): SavedListingSection => {
        const queriedSection = router.query.section?.toString() as SavedListingSection;
        const queriedIsValid = sections
            .map((section) => section.key)
            .includes(queriedSection);
        if (
            queriedIsValid &&
            savedListingsBySection &&
            savedListingsBySection[queriedSection]?.length
        ) {
            return queriedSection;
        } else if (orderedFilteredSavedListingsBySection?.length) {
            return orderedFilteredSavedListingsBySection[0]
                .key as SavedListingSection;
        } else return 'for-sale';
    };

    const [selectedSection, setSelectedSection] = useState<SavedListingSection>(
        getSelectedSection()
    );

    // set the selectedSection using above logic as soon as saved listings have loaded
    useEffect(() => {
        setSelectedSection(getSelectedSection());
    }, [savedListings?.length]);

    const onSectionChange = (section: SavedListingSection) => {
        router.push(`?section=${section}`, undefined, { shallow: true });
        setSelectedSection(section);
        trackSectionChange(section);
    };

    return { selectedSection, onSectionChange };
};
